const SAVE_REPORT_MODAL_TITLE = $localize`Save report`;
const COPY_REPORT_MODAL_TITLE = $localize`Clone report`;
const COPY_MODAL_TITLE = $localize`Copy of `;
const EDIT_REPORT_MODAL_TITLE = $localize`Edit report`;
const RENAME_REPORT_MODAL_TITLE = $localize`Rename report`;
const EDIT_SCHEDULE_REPORT_MODAL_TITLE = $localize`Edit scheduled report`;
const EDIT_SCHEDULE_REPORT_MODAL_SUBTITLE = $localize`You are now editing a scheduled report for your organization.`;
const SCHEDULE_REPORT_MODAL_TITLE = $localize`Create scheduled report`;
const SCHEDULE_REPORT_MODAL_SUBTITLE = $localize`You are now creating a scheduled report for your organization.`;
const COPY_SCHEDULE_REPORT_MODAL_TITLE = $localize`Copy scheduled report`;
const COPY_SCHEDULE_REPORT_MODAL_SUBTITLE = $localize`You are now copying this schedule to another report.`;
const DELETE_SAVED_REPORT_MODAL_TITLE = $localize`Delete report?`;
const DELETE_SAVED_REPORT_MODAL_SUBTITLE = $localize`This action cannot be undone.`;
const DELETE_SCHEDULE_MODAL_TITLE = $localize`Delete schedule?`;
const DELETE_SCHEDULE_MODAL_SUBTITLE = $localize`This action cannot be undone.`;

export const REPORT_ID_KEY = 'report_id';
export const REPORT_TYPE_KEY = 'report_type';

export enum MODE {
  COPY = 'copy',
  UPDATE = 'update',
  RENAME = 'rename',
  CREATE = 'create',
}

export interface IModalTitle {
  headerTitle: string;
  headerSubTitle?: string;
}

export interface IBannerMessage {
  failMessageMissingFilter?: string;
  errorMessage: string;
  successMessage: string;
}

export const saveReportModalTitle: IModalTitle = {
  headerTitle: SAVE_REPORT_MODAL_TITLE,
};

export const copyReportModalTitle: IModalTitle = {
  headerTitle: COPY_REPORT_MODAL_TITLE,
};

export const copyModalTitle: IModalTitle = {
  headerTitle: COPY_MODAL_TITLE,
};

export const editReportModalTitle: IModalTitle = {
  headerTitle: EDIT_REPORT_MODAL_TITLE,
};

export const renameReportModalTitle: IModalTitle = {
  headerTitle: RENAME_REPORT_MODAL_TITLE,
};

export const deleteSavedReportModalTitle: IModalTitle = {
  headerTitle: DELETE_SAVED_REPORT_MODAL_TITLE,
  headerSubTitle: DELETE_SAVED_REPORT_MODAL_SUBTITLE,
};

export const deleteScheduledReportModalTitle: IModalTitle = {
  headerTitle: DELETE_SCHEDULE_MODAL_TITLE,
  headerSubTitle: DELETE_SCHEDULE_MODAL_SUBTITLE,
};

export const editScheduledReportModalTitle: IModalTitle = {
  headerTitle: EDIT_SCHEDULE_REPORT_MODAL_TITLE,
  headerSubTitle: EDIT_SCHEDULE_REPORT_MODAL_SUBTITLE,
};

export const scheduleReportModalTitle: IModalTitle = {
  headerTitle: SCHEDULE_REPORT_MODAL_TITLE,
  headerSubTitle: SCHEDULE_REPORT_MODAL_SUBTITLE,
};

export const copyScheduledReportModalTitle: IModalTitle = {
  headerTitle: COPY_SCHEDULE_REPORT_MODAL_TITLE,
  headerSubTitle: COPY_SCHEDULE_REPORT_MODAL_SUBTITLE,
};

// Banner Messages Failure Filter Missing
const FAIL_CLONE_REPORT_FILTER_MISSING = $localize`Failed to clone report -- No Filters Selected`;
const FAIL_SAVE_REPORT_FILTER_MISSING = $localize`Failed to save report -- No Filters Selected`;
const FAIL_RENAME_REPORT_FILTER_MISSING = $localize`Failed to rename report -- No Filters Selected`;
const FAIL_UPDATE_REPORT_FILTER_MISSING = $localize`Failed to update report -- No Filters Selected`;
// Banner Error Messages
const ERROR_CLONE_REPORT = $localize`Failed to clone your report.`;
const ERROR_SAVE_REPORT = $localize`Failed to save your report.`;
const ERROR_UPDATE_REPORT = $localize`Failed to update your report.`;
const ERROR_RENAME_REPORT = $localize`Failed to rename your report.`;
const ERROR_DELETE_REPORT = $localize`Failed to delete this report.`;
// Banner Success Messages
const SUCCESS_CLONE_REPORT = $localize`Your report has been cloned.`;
const SUCCESS_SAVE_REPORT = $localize`Your report has been saved.`;
const SUCCESS_UPDATE_REPORT = $localize`Your report has been updated.`;
const SUCCESS_RENAME_REPORT = $localize`Your report has been renamed.`;
const SUCCESS_DELETE_REPORT = $localize`Your report has been deleted.`;

export const cloneReportBannerMessage: IBannerMessage = {
  failMessageMissingFilter: FAIL_CLONE_REPORT_FILTER_MISSING,
  errorMessage: ERROR_CLONE_REPORT,
  successMessage: SUCCESS_CLONE_REPORT,
};

export const renameReportBannerMessage: IBannerMessage = {
  failMessageMissingFilter: FAIL_RENAME_REPORT_FILTER_MISSING,
  errorMessage: ERROR_RENAME_REPORT,
  successMessage: SUCCESS_RENAME_REPORT,
};

export const updateReportBannerMessage: IBannerMessage = {
  failMessageMissingFilter: FAIL_UPDATE_REPORT_FILTER_MISSING,
  errorMessage: ERROR_UPDATE_REPORT,
  successMessage: SUCCESS_UPDATE_REPORT,
};

export const createReportBannerMessage: IBannerMessage = {
  failMessageMissingFilter: FAIL_SAVE_REPORT_FILTER_MISSING,
  errorMessage: ERROR_SAVE_REPORT,
  successMessage: SUCCESS_SAVE_REPORT,
};

export const deleteReportBannerMessage: IBannerMessage = {
  errorMessage: ERROR_DELETE_REPORT,
  successMessage: SUCCESS_DELETE_REPORT,
};

// Banner Messages Failure Filter Missing
const FAIL_CLONE_SCHEDULE_FILTER_MISSING = $localize`Failed to copy this schedule -- No Filters Selected`;
const FAIL_UPDATE_SCHEDULE_FILTER_MISSING = $localize`Failed to update this schedule -- No Filters Selected`;
const FAIL_SAVE_SCHEDULE_FILTER_MISSING = $localize`Failed to create this schedule -- No Filters Selected`;
// Banner Error Messages
const ERROR_CLONE_SCHEDULE = $localize`Failed to copy this schedule.`;
const ERROR_UPDATE_SCHEDULE = $localize`Failed to update this schedule.`;
const ERROR_SAVE_SCHEDULE = $localize`Failed to schedule this report.`;
const ERROR_DELETE_SCHEDULE = $localize`Failed to delete this schedule.`;
// Banner Success Messages
const SUCCESS_CLONE_SCHEDULE = $localize`Your schedule has been copied.`;
const SUCCESS_UPDATE_SCHEDULE = $localize`Your schedule has been updated.`;
const SUCCESS_SAVE_SCHEDULE = $localize`Your report has been scheduled.`;
const SUCCESS_DELETE_SCHEDULE = $localize`Your schedule has been deleted.`;

export const cloneScheduleBannerMessage: IBannerMessage = {
  failMessageMissingFilter: FAIL_CLONE_SCHEDULE_FILTER_MISSING,
  errorMessage: ERROR_CLONE_SCHEDULE,
  successMessage: SUCCESS_CLONE_SCHEDULE,
};

export const updateScheduleBannerMessage: IBannerMessage = {
  failMessageMissingFilter: FAIL_UPDATE_SCHEDULE_FILTER_MISSING,
  errorMessage: ERROR_UPDATE_SCHEDULE,
  successMessage: SUCCESS_UPDATE_SCHEDULE,
};

export const createScheduleBannerMessage: IBannerMessage = {
  failMessageMissingFilter: FAIL_SAVE_SCHEDULE_FILTER_MISSING,
  errorMessage: ERROR_SAVE_SCHEDULE,
  successMessage: SUCCESS_SAVE_SCHEDULE,
};

export const deleteScheduleBannerMessage: IBannerMessage = {
  errorMessage: ERROR_DELETE_SCHEDULE,
  successMessage: SUCCESS_DELETE_SCHEDULE,
};
